'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package-preload-img
 * @restrict A
 *
 * @description
 * #directive
 * Add preloading functonnality to image
 *
 * @param {string=BASE64_BLANK_PIXEL} defaultImage Default cached very small image to use while loading official image
 */

angular.module('v-tv-package').directive('vTvPackagePreloadImg', function vTvPackagePreloadImg(vTvPackagePreloadImgFactory, BASE64_BLANK_PIXEL) {

    return {
        restrict: 'A',
        terminal: true,
        priority: 100,
        link: function link(scope, $element, $attrs) {
            scope.default = $attrs.defaultImage || BASE64_BLANK_PIXEL;
            $attrs.$observe('ngSrc', function () {
                var url = $attrs.ngSrc;

                $attrs.$set('src', scope.default);
                vTvPackagePreloadImgFactory(url, function () {
                    $element.addClass('loaded').removeClass('loading loaded-fail no-fallback');
                    $attrs.$set('src', url);
                }, function () {
                    if ($attrs.fallbackImage !== angular.isUndefined) {
                        $element.addClass('fallback-loaded loaded').removeClass('loading');
                        $attrs.$set('src', $attrs.fallbackImage);
                    } else {
                        $element.addClass('loaded loaded-fail no-fallback').removeClass('loading');
                    }
                });
            });
        }
    };
});